<app-modal #modal>

  <span title>{{"Color List"|translate}}</span>

  <div body class="list-group">

    <!-- <div class="color-row header">
      <div>{{'SAPCODE'|translate}}</div>
      <div>{{'SIZE'|translate}}</div>
    </div> -->

    @for (color of colorList(); track $index) {
    <button class="btn color-row" [class.selected]="selectedColor()?.sapCode === color.sapCode"
      (click)="selectedColor.set(color)">
      <div class="img-wrapper">
        <app-asset [assetSrc]="color.media"></app-asset>
      </div>
      <div class="info">
        <div class="sapcode">{{color.sapCode}}</div>
        <div>{{color.color}}</div>
      </div>
    </button>
    }

  </div>

  <div footer class="footer">
    <button class="btn btn-primary" (click)="handleConfirm()" [disabled]="disabledConfirm()">
      {{"Select color"|translate}}&nbsp;{{selectedColor()?.color}}
    </button>
    <button class="btn btn-secondary" (click)="modal.dismiss()">
      {{"Close"|translate}}
    </button>
  </div>

</app-modal>
